<template>
    <div class="title-wrap">
        <h2 class="tit">{{ title }}</h2>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
    },
};
</script>

<style lang="scss" scoped>
.title-wrap {
    width: 100%;
    text-align: center;

    .tit {
        position: relative;
        font-size: 24px;
        display: inline-block;
        color: $defaultColor;

        &:after {
            content: "";
            position: absolute;
            top: 50%;
            left: -45px;
            width: 30px;
            height: 1px;
            background: #ccc;
        }
        &:before {
            content: "";
            position: absolute;
            top: 50%;
            right: -45px;
            width: 30px;
            height: 1px;
            background: #ccc;
        }
    }

    .sub {
        display: block;
        font-size: 12px;
        margin-top: 5px;
        color: $defaultColor;
    }
}
</style>